<template>
  <el-dialog
    title="请确认您的操作"
    :visible.sync="dialogVisible"
    width="30%"
    @close="handleClose"
  >
    <div class="confirm-content">
      <p>删除权限组同时会删除权限组下的所有权限，确认是否删除角色-{{form.name}}？</p>
    </div>
    
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">点错了</el-button>
      <el-button type="primary" @click="handleConfirm">确认删除</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deletePrivilegeGroup } from '@/api/frame/roleApi'

export default {
  name: 'DeletePrivilegeGroup',
  data() {
    return {
      dialogVisible: false,
      form: {
        pgId: '',
        name: ''
      }
    }
  },
  methods: {
    open(role) {
      this.form = {
        pgId: role.pgId,
        name: role.name
      }
      this.dialogVisible = true
    },
    handleClose() {
      this.form = {
        pgId: '',
        name: ''
      }
    },
    async handleConfirm() {
      try {
        const res = await deletePrivilegeGroup(this.form)
        if (res.code === 0) {
          this.$message.success('删除成功')
          this.dialogVisible = false
          this.$emit('refresh')
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.error('删除角色失败:', error)
        this.$message.error('删除角色失败')
      }
    }
  }
}
</script>

<style scoped>
.confirm-content {
  text-align: center;
  margin-bottom: 20px;
}
</style>